import { GameEvent, ActiveEvent, GameState } from '../domain/types.ts';
import { DeterministicRNG } from './rng.ts';
import { GAME_CONFIG } from '../config/gameConfig.ts';

export const GAME_EVENTS: GameEvent[] = [
  {
    id: 'event-rain',
    type: 'rain',
    trigger: 'random',
    durationMs: GAME_CONFIG.events.rain.durationMs,
    severity: 0.5,
    options: [
      {
        id: 'opt-open-umbrella',
        label: 'Bung ô bạt che chắn (-20.000đ, Giữ nguyên khách)',
        moneyDelta: -20_000,
        trafficDelta: 0,
        reputationDelta: 2,
      },
      {
        id: 'opt-rain-discount',
        label: 'Giảm giá 30% kích cầu (-30% Giá, Tăng khách)',
        trafficDelta: 0.2,
        moneyDelta: 0,
        reputationDelta: 1,
      },
      {
        id: 'opt-rain-wait',
        label: 'Ngồi đợi tạnh mưa (Giảm 50% lượng khách)',
        trafficDelta: -GAME_CONFIG.events.rain.trafficPenalty,
      },
    ],
  },
  {
    id: 'event-raid',
    type: 'raid',
    trigger: 'heat_threshold',
    durationMs: GAME_CONFIG.events.raid.durationMs,
    severity: 0.8,
    options: [
      {
        id: 'opt-pack-up',
        label: 'Dọn bàn ghế né trật tự (-Heat, Tạm đóng cửa)',
        heatDelta: GAME_CONFIG.heat.sinks.tempClosure,
        reputationDelta: -2,
      },
      {
        id: 'opt-pay-fine',
        label: 'Nộp phạt hành chính (-50.000đ, Xóa hết Heat)',
        moneyDelta: -50_000,
        heatDelta: -0.4,
        reputationDelta: 1,
      },
      {
        id: 'opt-bribe-chair',
        label: 'Nộp phạt chuộc ghế bị thu (-80.000đ, Khôi phục quán)',
        moneyDelta: -80_000,
        heatDelta: -0.5,
        reputationDelta: 0,
      },
      {
        id: 'opt-buy-new-chairs',
        label: 'Tự mua ghế mới thay thế (-100.000đ, Khôi phục quán)',
        moneyDelta: -100_000,
        heatDelta: -0.3,
        reputationDelta: 1,
      },
    ],
  },
  {
    id: 'event-price-war',
    type: 'price_war',
    trigger: 'random',
    durationMs: GAME_CONFIG.events.priceWar.durationMs,
    severity: 0.6,
    options: [
      {
        id: 'opt-war-match',
        label: 'Khô máu giảm giá bằng đối thủ (+Khách, Lãi mỏng)',
        trafficDelta: GAME_CONFIG.events.priceWar.trafficBoostWinner,
        reputationDelta: 1,
      },
      {
        id: 'opt-war-quality',
        label: 'Giữ nguyên giá, tặng kèm trà đá (+Danh tiếng)',
        reputationDelta: 5,
        moneyDelta: -10_000,
      },
      {
        id: 'opt-war-ignore',
        label: 'Kệ đối thủ (Giảm 20% lượng khách)',
        trafficDelta: -0.2,
      },
    ],
  },
  {
    id: 'event-unpaid_bill',
    type: 'unpaid_bill',
    trigger: 'random',
    durationMs: GAME_CONFIG.events.unpaidBill.durationMs,
    severity: 0.4,
    options: [
      {
        id: 'opt-chase-bill',
        label: 'Đuổi theo đòi (+35.000đ, +Heat, -1 Uy tín)',
        moneyDelta: 35_000,
        heatDelta: 0.1,
        reputationDelta: -1,
      },
      {
        id: 'opt-let-go',
        label: 'Coi như của đi thay người (-35.000đ, +1 Uy tín)',
        moneyDelta: -35_000,
        heatDelta: 0,
        reputationDelta: 1,
      },
      {
        id: 'opt-qr-pay',
        label: 'Dán biển QR trả trước (-15.000đ, +2 Uy tín)',
        moneyDelta: -15_000,
        heatDelta: 0,
        reputationDelta: 2,
      },
    ],
  },
  {
    id: 'event-rival_sabotage',
    type: 'rival_sabotage',
    trigger: 'random',
    durationMs: GAME_CONFIG.events.rivalSabotage.durationMs,
    severity: 0.6,
    options: [
      {
        id: 'opt-sabotage-price',
        label: 'Giảm giá khô máu giành khách (+15% khách, -15.000đ)',
        moneyDelta: -15_000,
        trafficDelta: 0.15,
        reputationDelta: 1,
      },
      {
        id: 'opt-sabotage-tea',
        label: 'Mời trà dĩ hòa vi quý (-20.000đ, +5 Uy tín)',
        moneyDelta: -20_000,
        heatDelta: -0.1,
        reputationDelta: 5,
      },
      {
        id: 'opt-sabotage-report',
        label: 'Báo trật tự xử lý đối thủ (+Heat khu vực 0.15)',
        heatDelta: 0.15,
        reputationDelta: -2,
      },
    ],
  },
  {
    id: 'event-street_brawl',
    type: 'street_brawl',
    trigger: 'random',
    durationMs: GAME_CONFIG.events.streetBrawl.durationMs,
    severity: 0.7,
    options: [
      {
        id: 'opt-brawl-repair',
        label: 'Tự bỏ tiền sửa chữa bàn ghế (-50.000đ, An ổn)',
        moneyDelta: -50_000,
        heatDelta: 0,
        reputationDelta: 1,
      },
      {
        id: 'opt-brawl-demand',
        label: 'Giữ người bắt đền (+50.000đ đền bù, +Heat)',
        moneyDelta: 50_000,
        heatDelta: 0.15,
        reputationDelta: -2,
      },
      {
        id: 'opt-brawl-shelter',
        label: 'Tạm đóng cửa lánh nạn (-10% khách, An toàn)',
        trafficDelta: -0.1,
        heatDelta: -0.1,
        reputationDelta: 0,
      },
    ],
  },
  {
    id: 'event-extreme_weather',
    type: 'extreme_weather',
    trigger: 'random',
    durationMs: GAME_CONFIG.events.extremeWeather.durationMs,
    severity: 0.8,
    options: [
      {
        id: 'opt-weather-takeaway',
        label: 'Bán mang đi / ship tận nơi (+25.000đ, Giữ khách)',
        moneyDelta: 25_000,
        trafficDelta: 0.1,
        reputationDelta: 2,
      },
      {
        id: 'opt-weather-reinforce',
        label: 'Gia cố bạt che & quạt phun sương (-40.000đ, +3 Uy tín)',
        moneyDelta: -40_000,
        trafficDelta: 0,
        reputationDelta: 3,
      },
      {
        id: 'opt-weather-rest',
        label: 'Nghỉ bán tạm thời né bão nhiệt (-0.1 Heat)',
        heatDelta: -0.1,
        trafficDelta: -0.3,
        reputationDelta: 0,
      },
    ],
  },
  {
    id: 'event-viral_tiktok',
    type: 'viral_tiktok',
    trigger: 'random',
    durationMs: GAME_CONFIG.events.viralTiktok.durationMs,
    severity: 0.9,
    options: [
      {
        id: 'opt-tiktok-treat',
        label: 'Mời trọn gói idol (-30.000đ, +80% khách, +15 Uy tín)',
        moneyDelta: -30_000,
        trafficDelta: 0.8,
        reputationDelta: 15,
      },
      {
        id: 'opt-tiktok-normal',
        label: 'Phục vụ chu đáo như thường (+40% khách, +5 Uy tín)',
        moneyDelta: 0,
        trafficDelta: 0.4,
        reputationDelta: 5,
      },
      {
        id: 'opt-tiktok-combo',
        label: 'Mở bán combo idol đặc biệt (+50.000đ, +20% khách)',
        moneyDelta: 50_000,
        trafficDelta: 0.2,
        reputationDelta: 3,
      },
    ],
  },
];

export class EventEngine {
  private rng: DeterministicRNG;
  private lastCheckAt = Date.now();

  constructor(rng: DeterministicRNG) {
    this.rng = rng;
  }

  public checkTriggers(state: Readonly<GameState>, forceCheck = false): ActiveEvent | null {
    // Chưa tạo/mở quán vỉa hè thì không bao giờ kích hoạt biến cố
    if (!state.player.ownedStalls || state.player.ownedStalls.length === 0) {
      return null;
    }

    if (state.activeEvent) {
      // Đang có event
      if (Date.now() >= state.activeEvent.expiresAt) {
        return null; // Expired
      }
      return state.activeEvent;
    }

    const now = Date.now();
    if (!forceCheck && now - this.lastCheckAt < GAME_CONFIG.events.checkIntervalMs) {
      return null;
    }
    this.lastCheckAt = now;

    // 1. Kiểm tra Heat Threshold (Raid) - Có perk-license giảm 80%, perk-scout giảm 30%
    const hasLicense = state.player.unlockedPerks?.includes('perk-license');
    const hasScout = state.player.unlockedPerks?.includes('perk-scout');
    let effectiveHeat = state.player.heat;
    if (hasLicense) effectiveHeat *= 0.2;
    if (hasScout) effectiveHeat *= 0.7;

    if (effectiveHeat >= GAME_CONFIG.events.raid.heatThreshold) {
      return this.activateEvent('event-raid');
    }

    // 2. Random trigger (khi bán ca đêm thì nguy cơ biến cố cao hơn)
    const triggerThreshold = (state.isOvertimeActive && state.currentShift === 'night') ? 0.35 : 0.20;
    const roll = this.rng.next();
    if (roll < triggerThreshold) {
      const candidates: string[] = [
        'event-price_war',
        'event-unpaid_bill',
        'event-rival_sabotage',
        'event-street_brawl',
      ];
      // Nếu quán chưa có ô che chắn hoặc đang mưa
      if (!state.player.upgrades['umbrella'] || state.weather?.type === 'rainy') {
        candidates.push('event-rain');
      }
      // Thời tiết cực đoan khi mưa to hoặc nắng gắt
      if (state.weather?.type === 'rainy' || state.weather?.type === 'hot') {
        candidates.push('event-extreme_weather');
      }
      // Idol ghé khi quán có chút uy tín
      if (state.player.reputation >= 25) {
        candidates.push('event-viral_tiktok');
      }

      const chosen = candidates[this.rng.nextInt(0, candidates.length - 1)]!;
      return this.activateEvent(chosen);
    }

    return null;
  }

  private activateEvent(eventId: string): ActiveEvent | null {
    const template = GAME_EVENTS.find((e) => e.id === eventId);
    if (!template) return null;

    return {
      id: `${template.id}-${Date.now()}`,
      type: template.type,
      startedAt: Date.now(),
      expiresAt: Date.now() + template.durationMs,
      severity: template.severity,
      optionIds: template.options.map((o) => o.id),
    };
  }
}
